import './eventHandlers';
import './search';
import './xor';
import './lecturesAccorditionMenu';